import { render, staticRenderFns } from "./ReSearchCardStaffBigSettings.vue?vue&type=template&id=210e93d5&scoped=true"
import script from "./ReSearchCardStaffBigSettings.vue?vue&type=script&lang=js"
export * from "./ReSearchCardStaffBigSettings.vue?vue&type=script&lang=js"
import style0 from "./ReSearchCardStaffBigSettings.vue?vue&type=style&index=0&id=210e93d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210e93d5",
  null
  
)

export default component.exports